import React from "react";

const Form = ({ setInputText, todos, setTodos, inputText, setStatus }) => {
  const handleInput = (e) => {
    console.log(e.target.value);
    setInputText(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setTodos([
      ...todos,
      { text: inputText, completed: false, id: Math.random() * 1000 },
    ]);
    setInputText("");
  };
  // const handleStatus = () => {}
  const handleFilter = (e) => {
    setStatus(e.target.value)
  }
  return (
    <div>
      <form>
        <input
          value={inputText}
          onChange={handleInput}
          type="text"
          className="todo-input"
        />
        <button onClick={handleSubmit} className="todo-button" type="submit">
          <i className="fas fa-plus-square"></i>
        </button>
        <div className="select">
          <select onChange={handleFilter} name="todos" className="filter-todo">
            <option value="all">All</option>
            <option value="completed">Completed</option>
            <option value="uncompleted">Uncompleted</option>
          </select>
        </div>
      </form>
    </div>
  );
};

export default Form;
